import React from "react";
import BannerHeader from "../../Component/Header/BannerHeader";
import Footer from "../../Component/Footer/Footer";
import "../legal.css";

const Tac = () => {
  return (
    <>
      <BannerHeader />
      {/* Banner Section matching homepage */}
      <div
        className="container-fluid px-md-0 legal-hero"
        style={{ background: "#F1F5F8 0% 0% no-repeat padding-box" }}
      >
        <div className="row mx-auto">
          <div className="col px-0 text-center">
            <div className="bannersub">Legal</div>
            <div className="bannermain">Terms and Conditions</div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div
        className="container-fluid legal-content"
        style={{ background: "#F1F5F8 0% 0% no-repeat padding-box" }}
      >
        <div className="row">
          <div className="col-xl-8 mx-auto legal-document">
            {/* Last Updated Date */}
            <p className="greytext pt-4">Last Updated: February 17, 2025</p>

            {/* TAC Sections */}
            <section className="mb-5">
              <h2 className="homepagebold">1. Introduction</h2>
              <p className="backtohome">
                Welcome to Simule ("we," "us," "our," or the "Company"). These
                Terms and Conditions ("Terms") constitute a legally binding
                agreement between you ("User," "you," or "your") and Simule,
                governing your access to and use of Simule's platform,
                including our website (www.simule.com), mobile applications,
                smart contracts, blockchain services, and all associated
                features, functionalities, and content (collectively, the
                "Services") that enable the creation, purchase, sale, and
                management of Simule Digital Land (SDL) tokens.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">2. Acceptance of Terms</h2>
              <p className="backtohome">
                <span className="backtohomebold">2.1.</span> By accessing,
                registering for, or using our Services, you expressly
                acknowledge that you have read, understood, and agree to be
                bound by these Terms, including any guidelines, policies, or
                future modifications.
              </p>
              <p className="backtohome">
                <span className="backtohomebold">2.2.</span> If you are
                accessing or using the Services on behalf of a business
                entity, you represent and warrant that you have the authority
                to bind such entity to these Terms.
              </p>
              <p className="backtohome">
                <span className="backtohomebold">2.3.</span> If you do not
                agree to any portion of these Terms, you must immediately
                discontinue access to and use of our Services.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">3. Definitions</h2>
              <p className="backtohome">
                <span className="backtohomebold">3.1.</span> "SDL" (Simule
                Digital Land) refers to ERC-1155 non-fungible tokens
                representing fractional ownership of virtual land, with each
                token corresponding to specific geographic coordinates and
                dimensions as defined by the SDL smart contract.
              </p>
              <p className="backtohome">
                <span className="backtohomebold">3.2.</span> "Simule Coin"
                refers to the platform's native digital currency used for
                transactions, governed by smart contracts deployed on the
                Ethereum blockchain.
              </p>
              <p className="backtohome">
                <span className="backtohomebold">3.3.</span> "Smart Contracts"
                refer to self-executing contracts with terms and conditions
                directly written into code on the blockchain, which
                automatically execute and enforce the agreed-upon terms.
              </p>
              <p className="backtohome">
                <span className="backtohomebold">3.4.</span> "Platform" refers
                to the entire Simule ecosystem, including all associated
                services, technologies, smart contracts, and infrastructure.
              </p>
              <p className="backtohome">
                <span className="backtohomebold">3.5.</span> "Web Mercator
                Mapping" refers to the geographic projection system used by
                the Platform to represent land parcels, including custom polar
                region mapping solutions.
              </p>
              <p className="backtohome">
                <span className="backtohomebold">3.6.</span> "Connector" refers
                to a Platform participant who facilitates transactions without
                verified real-world land ownership.
              </p>
              <p className="backtohome">
                <span className="backtohomebold">3.7.</span> "Real Owner"
                refers to a Platform participant with verified ownership of
                corresponding real-world land.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">4. Eligibility</h2>
              <h3 className="backtohomebold">4.1. Age and Capacity Requirements</h3>
              <ul>
                <li className="backtohome">You must be at least 18 years old</li>
                <li className="backtohome">
                  You must have the legal capacity to form binding contracts
                </li>
                <li className="backtohome">
                  You must not be barred from using blockchain-based services
                  under applicable laws
                </li>
              </ul>
              <h3 className="backtohomebold">4.2. Geographic Restrictions</h3>
              <ul>
                <li className="backtohome">
                  You must not be a resident of or located in any jurisdiction
                  where participation in digital token transactions is
                  prohibited
                </li>
                <li className="backtohome">
                  You are responsible for ensuring compliance with your local
                  laws and regulations
                </li>
              </ul>
              <h3 className="backtohomebold">4.3. Technical Requirements</h3>
              <ul>
                <li className="backtohome">
                  You must maintain a compatible cryptocurrency wallet
                </li>
                <li className="backtohome">
                  You must have sufficient technical knowledge to interact
                  with blockchain technology
                </li>
                <li className="backtohome">
                  You must secure and maintain your private keys and wallet
                  access
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">5. SDL Token Ownership</h2>
              <h3 className="backtohomebold">5.1. Token Rights and Properties</h3>
              <ul>
                <li className="backtohome">
                  Each SDL token represents ownership of one square foot of
                  virtual land
                </li>
                <li className="backtohome">
                  Tokens are minted according to the Web Mercator projection
                  system
                </li>
                <li className="backtohome">
                  Token coordinates are permanently encoded in the token ID
                </li>
                <li className="backtohome">
                  Areas vary by latitude according to mathematical formulas
                  defined in the whitepaper
                </li>
                <li className="backtohome">
                  Token ownership is recorded on the Ethereum blockchain and
                  is immutable
                </li>
                <li className="backtohome">
                  Ownership of SDL tokens does not confer any rights to
                  physical land
                </li>
              </ul>
              <h3 className="backtohomebold">5.2. Minting Restrictions and Processes</h3>
              <ul>
                <li className="backtohome">
                  Minting is subject to availability within each geographic
                  tile
                </li>
                <li className="backtohome">
                  Maximum token limits are calculated based on real-world land
                  area
                </li>
                <li className="backtohome">
                  Smart contracts enforce minting limits through automated
                  verification
                </li>
                <li className="backtohome">
                  Minting requests are processed in order of transaction
                  confirmation
                </li>
                <li className="backtohome">
                  Multiple users may mint tokens from the same tile up to the
                  maximum limit
                </li>
                <li className="backtohome">
                  We reserve the right to adjust minting parameters for
                  platform stability
                </li>
                <li className="backtohome">
                  Minting may be temporarily suspended for technical
                  maintenance
                </li>
              </ul>
              <h3 className="backtohomebold">5.3. Token Attributes and Metadata</h3>
              <ul>
                <li className="backtohome">
                  Each token contains embedded geographic coordinates
                </li>
                <li className="backtohome">
                  Token IDs are generated using the formula: tID = y ^ 262144 +
                  x
                </li>
                <li className="backtohome">
                  Token attributes are derived from on-chain data without
                  external metadata
                </li>
                <li className="backtohome">
                  Token visuals are generated from OpenStreetMap data for
                  display purposes only
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">6. Trading and Transactions</h2>
              <h3 className="backtohomebold">6.1. Peer-to-Peer Transactions</h3>
              <ul>
                <li className="backtohome">
                  All transactions occur directly between users through smart
                  contracts
                </li>
                <li className="backtohome">
                  Smart contracts automatically execute transfers upon
                  condition fulfillment
                </li>
                <li className="backtohome">
                  Users must verify all transaction details before
                  confirmation
                </li>
                <li className="backtohome">
                  Transactions are irreversible once confirmed on the
                  blockchain
                </li>
                <li className="backtohome">
                  Users are responsible for inputting correct wallet addresses
                </li>
                <li className="backtohome">
                  Gas fees are paid by the initiating party
                </li>
              </ul>
              <h3 className="backtohomebold">6.2. Fees and Payments</h3>
              <ul>
                <li className="backtohome">
                  Each square foot of digital land costs 0.0000040 ETH
                </li>
                <li className="backtohome">
                  Platform fees may apply to certain transactions
                </li>
                <li className="backtohome">
                  All fees are non-refundable once transactions are confirmed
                </li>
                <li className="backtohome">
                  Gas fees vary based on network conditions
                </li>
                <li className="backtohome">
                  Users are responsible for all applicable taxes and duties
                </li>
                <li className="backtohome">
                  Payment amounts are fixed in ETH and not pegged to fiat
                  currencies
                </li>
              </ul>
              <h3 className="backtohomebold">6.3. Transaction Verification</h3>
              <ul>
                <li className="backtohome">
                  Users must verify all transaction details before signing
                </li>
                <li className="backtohome">
                  The Platform provides transaction preview functionality
                </li>
                <li className="backtohome">
                  Users should confirm recipient addresses multiple times
                </li>
                <li className="backtohome">
                  Transaction status can be verified on block explorers
                </li>
                <li className="backtohome">
                  Failed transactions may still incur gas fees
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">7. User Responsibilities and Conduct</h2>
              <h3 className="backtohomebold">7.1. Security Obligations</h3>
              <ul>
                <li className="backtohome">
                  Maintain the security of wallet and private keys
                </li>
                <li className="backtohome">
                  Use strong passwords and enable two-factor authentication
                  where available
                </li>
                <li className="backtohome">
                  Never share private keys or wallet seed phrases
                </li>
                <li className="backtohome">
                  Report any suspicious activity immediately
                </li>
                <li className="backtohome">
                  Keep software and devices updated and secure
                </li>
              </ul>
              <h3 className="backtohomebold">7.2. Platform Usage</h3>
              <ul>
                <li className="backtohome">
                  Provide accurate and complete information
                </li>
                <li className="backtohome">
                  Update account information as needed
                </li>
                <li className="backtohome">
                  Use the Platform for legitimate purposes only
                </li>
                <li className="backtohome">
                  Respect the rights of other users
                </li>
                <li className="backtohome">
                  Follow Platform guidelines and instructions
                </li>
              </ul>
              <h3 className="backtohomebold">7.3. Prohibited Activities</h3>
              <ul>
                <li className="backtohome">
                  No manipulation of platform mechanics
                </li>
                <li className="backtohome">
                  No interference with other users' transactions
                </li>
                <li className="backtohome">
                  No use of automated trading bots without approval
                </li>
                <li className="backtohome">
                  No creation of false or misleading information
                </li>
                <li className="backtohome">
                  No attempt to reverse engineer smart contracts
                </li>
                <li className="backtohome">
                  No use of the Platform for illegal activities
                </li>
                <li className="backtohome">
                  No creation of multiple accounts to circumvent restrictions
                </li>
              </ul>
              <h3 className="backtohomebold">7.4. Risk Acknowledgment</h3>
              <ul>
                <li className="backtohome">
                  Users acknowledge blockchain transaction risks
                </li>
                <li className="backtohome">
                  Users understand the volatility of cryptocurrency markets
                </li>
                <li className="backtohome">
                  Users accept responsibility for their trading decisions
                </li>
                <li className="backtohome">
                  Users understand the irreversible nature of blockchain
                  transactions
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">8. Intellectual Property Rights</h2>
              <h3 className="backtohomebold">8.1. Platform Rights</h3>
              <ul>
                <li className="backtohome">
                  All platform content is owned by Simule
                </li>
                <li className="backtohome">
                  Software, algorithms, and smart contracts are proprietary
                </li>
                <li className="backtohome">
                  Platform branding and trademarks are protected
                </li>
                <li className="backtohome">
                  Users receive a limited, revocable license to use features
                </li>
                <li className="backtohome">
                  No right to copy or modify Platform code is granted
                </li>
              </ul>
              <h3 className="backtohomebold">8.2. User Content and Data</h3>
              <ul>
                <li className="backtohome">
                  Users retain rights to their original content
                </li>
                <li className="backtohome">
                  Users grant Simule a perpetual license to use content
                </li>
                <li className="backtohome">
                  We may use anonymized data for analytics
                </li>
                <li className="backtohome">
                  We may share aggregated data with partners
                </li>
                <li className="backtohome">
                  User content must not infringe third-party rights
                </li>
              </ul>
              <h3 className="backtohomebold">8.3. Smart Contract License</h3>
              <ul>
                <li className="backtohome">
                  Smart contracts are deployed under specific licenses
                </li>
                <li className="backtohome">
                  Users may interact with but not modify contracts
                </li>
                <li className="backtohome">
                  Contract code may be verified on block explorers
                </li>
                <li className="backtohome">
                  Additional permissions required for commercial use
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">9. Disclaimers and Limitations of Liability</h2>
              <h3 className="backtohomebold">9.1. Service Disclaimer</h3>
              <ul>
                <li className="backtohome">
                  Platform provided "as is" without warranties
                </li>
                <li className="backtohome">
                  No guarantee of continuous availability
                </li>
                <li className="backtohome">
                  No warranty of fitness for particular purpose
                </li>
                <li className="backtohome">
                  Technical issues may affect functionality
                </li>
                <li className="backtohome">
                  Market conditions may impact token value
                </li>
              </ul>
              <h3 className="backtohomebold">9.2. Risk Disclaimers</h3>
              <ul>
                <li className="backtohome">
                  Cryptocurrency trading carries inherent risks
                </li>
                <li className="backtohome">
                  Market volatility can affect token values
                </li>
                <li className="backtohome">
                  Smart contract risks are assumed by users
                </li>
                <li className="backtohome">
                  Network congestion may delay transactions
                </li>
                <li className="backtohome">
                  Technical failures may impact service availability
                </li>
              </ul>
              <h3 className="backtohomebold">9.3. Limitation of Liability</h3>
              <ul>
                <li className="backtohome">
                  Maximum liability limited to token purchase amount
                </li>
                <li className="backtohome">
                  No liability for consequential damages
                </li>
                <li className="backtohome">
                  No responsibility for third-party actions
                </li>
                <li className="backtohome">
                  Force majeure events exclude liability
                </li>
                <li className="backtohome">
                  User assumes all trading risks
                </li>
              </ul>
              <h3 className="backtohomebold">9.4. Indemnification</h3>
              <ul>
                <li className="backtohome">
                  Users indemnify Simule against claims
                </li>
                <li className="backtohome">
                  Users responsible for legal defense costs
                </li>
                <li className="backtohome">
                  Indemnification survives term termination
                </li>
                <li className="backtohome">
                  Company may participate in defense
                </li>
                <li className="backtohome">
                  Settlement requires Company approval
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">10. Termination</h2>
              <h3 className="backtohomebold">10.1. Termination Rights</h3>
              <ul>
                <li className="backtohome">
                  We may terminate service access at our discretion
                </li>
                <li className="backtohome">
                  Termination may occur without prior notice
                </li>
                <li className="backtohome">
                  Violations may lead to immediate termination
                </li>
                <li className="backtohome">
                  Users may terminate by discontinuing use
                </li>
                <li className="backtohome">
                  Certain obligations survive termination
                </li>
              </ul>
              <h3 className="backtohomebold">10.2. Effects of Termination</h3>
              <ul>
                <li className="backtohome">
                  Token ownership remains on blockchain
                </li>
                <li className="backtohome">
                  Trading abilities may be restricted
                </li>
                <li className="backtohome">
                  Platform access may be revoked
                </li>
                <li className="backtohome">
                  Pending transactions may be cancelled
                </li>
                <li className="backtohome">
                  User content may be retained
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">11. Modifications and Updates</h2>
              <h3 className="backtohomebold">11.1. Terms Modifications</h3>
              <ul>
                <li className="backtohome">
                  We may modify terms at any time
                </li>
                <li className="backtohome">
                  Notice provided for material changes
                </li>
                <li className="backtohome">
                  Continued use accepts modifications
                </li>
                <li className="backtohome">
                  Users should regularly review terms
                </li>
                <li className="backtohome">
                  Objections require service discontinuation
                </li>
              </ul>
              <h3 className="backtohomebold">11.2. Platform Updates</h3>
              <ul>
                <li className="backtohome">
                  Features may be added or removed
                </li>
                <li className="backtohome">
                  Smart contracts may be upgraded
                </li>
                <li className="backtohome">
                  User interface may change
                </li>
                <li className="backtohome">
                  Technical requirements may update
                </li>
                <li className="backtohome">
                  Advance notice given when possible
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">12. Dispute Resolution</h2>
              <h3 className="backtohomebold">12.1. Governing Law</h3>
              <ul>
                <li className="backtohome">
                  Terms governed by [Jurisdiction] law
                </li>
                <li className="backtohome">
                  Blockchain transactions governed by smart contracts
                </li>
                <li className="backtohome">
                  Conflicts resolved under [Jurisdiction] law
                </li>
                <li className="backtohome">
                  International sales conventions excluded
                </li>
              </ul>
              <h3 className="backtohomebold">12.2. Dispute Process</h3>
              <ul>
                <li className="backtohome">
                  Informal resolution attempted first
                </li>
                <li className="backtohome">
                  Mediation before litigation
                </li>
                <li className="backtohome">
                  Arbitration for technical disputes
                </li>
                <li className="backtohome">
                  Court action as last resort
                </li>
                <li className="backtohome">
                  Class actions waived
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">13. Contact Information</h2>
              <p className="backtohome">
                For any questions regarding these Terms:
              </p>
              <ul>
                <li className="backtohome">
                  Email: rajasekar@simule.com
                </li>
                <li className="backtohome">
                  Address: 447 Broadway, 2nd Floor Suite #1458, New York, New
                  York 10013, United States
                </li>
              </ul>
              <p className="backtohome">
                By using our Services, you acknowledge that you have read,
                understood, and agreed to these Terms and Conditions in their
                entirety.
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Tac;
